exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-address[data-v-6d935f9c] {\n    margin-right: 20px;\n}\n", ""]);

// exports
